export default __webpack_public_path__ + "static/media/Logo_portal_web.186f3050.png";